/*
 * Open the header dropdowns on hover (desktop pointers only). Click and keyboard still work
 * through Dawn's <header-menu>/<details>. A short close delay lets the pointer travel from the
 * menu item into the submenu without it snapping shut.
 */
(() => {
  const hoverable = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  // Parent labels (Furnishings, Fox Hill Home) are links to their collection.
  // On touch screens with the desktop menu, the first tap opens the dropdown and a second tap follows the link.
  document.querySelectorAll('.header__inline-menu .fhf-menu-parent-link').forEach((link) => {
    const details = link.closest('details');
    link.addEventListener('click', (event) => {
      event.stopPropagation(); // keep the summary from toggling the dropdown shut
      if (!hoverable && details && !details.open) {
        event.preventDefault();
        details.setAttribute('open', '');
      }
    });
  });

  if (!hoverable) return;
  const CLOSE_DELAY = 150;

  document.querySelectorAll('.header__inline-menu details').forEach((details) => {
    let timer;
    const open = () => {
      clearTimeout(timer);
      // close any sibling dropdown that is still open
      document.querySelectorAll('.header__inline-menu details[open]').forEach((d) => {
        if (d !== details) d.removeAttribute('open');
      });
      if (!details.open) details.setAttribute('open', '');
    };
    const close = () => {
      timer = setTimeout(() => details.removeAttribute('open'), CLOSE_DELAY);
    };
    details.addEventListener('mouseenter', open);
    details.addEventListener('mouseleave', close);
    // a mouse click on an item that hover already opened would toggle it shut; keep it open.
    // keyboard activation (Enter/Space, event.detail === 0) still toggles normally.
    details.querySelector('summary').addEventListener('click', (event) => {
      if (event.detail > 0 && details.open) event.preventDefault();
    });
  });
})();
